import { useState } from 'react';
import { JOB_APP_PIN, PIN_SESSION_KEY } from './constants';

export default function PinGate({ children }) {
    const [verified, setVerified] = useState(
        () => sessionStorage.getItem(PIN_SESSION_KEY) === 'true'
    );
    const [pin, setPin] = useState('');
    const [error, setError] = useState(false);

    function handleSubmit(e) {
        e.preventDefault();
        if (pin === JOB_APP_PIN) {
            sessionStorage.setItem(PIN_SESSION_KEY, 'true');
            setVerified(true);
        } else {
            setError(true);
            setPin('');
        }
    }

    if (verified) return children;

    return (
        <div className="pin-gate">
            <div className="pin-gate-card">
                <h2>Acceso Restringido</h2>
                <p>Ingresa el PIN para ver las solicitudes de empleo.</p>
                <form onSubmit={handleSubmit}>
                    <input
                        type="password"
                        maxLength={4}
                        value={pin}
                        onChange={(e) => {
                            setPin(e.target.value);
                            setError(false);
                        }}
                        placeholder="PIN"
                        autoFocus
                    />
                    <button type="submit" className="primaryButton">Ingresar</button>
                </form>
                {error && <p className="pin-error">PIN incorrecto</p>}
            </div>
        </div>
    );
}
